// extracted by mini-css-extract-plugin
module.exports = {"box":"_Box_box__1nK62"};